import { FC} from "react";
import { StatisticsObjectType } from "../caseVolumeLineChart/types";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { top_payors_details_multiple, topPayor } from "src/pages/manufacturer/types";
import { objectToQueryString } from "src/helpers";

const CustomTopPayorList: FC<StatisticsObjectType> = ({ StatisticsObjectType }): JSX.Element => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const handleLinkClick = (e: React.MouseEvent, itemName: string) => {
    if (itemName === "ALL TOP 10") {
      e.preventDefault(); // Prevent the default link behavior
      window.history.pushState(null, "", location.pathname); // Update URL to current pathname
      window.location.reload(); // Reload the page
    }
  };

  return (
    <table className="table table-sm table-responsive">
      <thead className="table-light sticky-top">
        <tr className="text-center">
          <th>Plan Name</th>
          <th>Cases</th>
          <th style={{minWidth:'100px'}}>% of Cases</th>
        </tr>
      </thead>
      <tbody>
        {StatisticsObjectType.top_payors_details 
          && !StatisticsObjectType.top_payors_details.hasOwnProperty("cvg") 
          && !StatisticsObjectType.top_payors_details.hasOwnProperty("pa_req") 
          && (StatisticsObjectType.top_payors_details as topPayor[]).length > 0 
          && (StatisticsObjectType.top_payors_details as topPayor[]).map((item, key) => (
            <tr className="text-center" key={key}>
              <td>
                <Link
                  to={{
                    pathname: window.location.pathname,
                    search: objectToQueryString({
                      ...(Object.fromEntries([...searchParams])),
                      insurance_name: encodeURIComponent(item?.name || ""),
                    })
                  }}
                  onClick={(e) => handleLinkClick(e, item?.name || "")}
                  className="fw-normal fs-6 btn btn-link link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover p-0"
                  reloadDocument
                >
                  {item.name ? item.name : ""}
                </Link>
              </td>
              <td>{item?.value}</td>
              <td>{item.percentage ? `${item.percentage.toFixed(2)} %` : '0.00'}</td>
            </tr>
            ))
        }
        {StatisticsObjectType.top_payors_details 
          && StatisticsObjectType.top_payors_details.hasOwnProperty("cvg") 
          && StatisticsObjectType.top_payors_details.hasOwnProperty("pa_req") 
          && StatisticsObjectType.top_payors_details.hasOwnProperty("top_payors") 
          && (StatisticsObjectType.top_payors_details as top_payors_details_multiple).top_payors.length>0
          // && StatisticsObjectType.top_payors_details.top_payors.length>0 
          &&
          (StatisticsObjectType.top_payors_details as top_payors_details_multiple).top_payors.map((item, key) => (
            <tr className="text-center" key={key}>
              <td>
                <Link
                  to={{
                    pathname: window.location.pathname,
                    search: objectToQueryString({
                      ...(Object.fromEntries([...searchParams])),
                      insurance_name: encodeURIComponent(item?.name || ""),
                    })
                  }}
                  onClick={(e) => handleLinkClick(e, item?.name || "")}
                  className="fw-normal fs-6 btn btn-link link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover p-0"
                >
                  {item?.name}
                </Link>
              </td>
              <td>{item?.value}</td>
              <td>{item?.percentage}</td>
            </tr>
          ))
        }
      </tbody>
    </table>
  );
};

export default CustomTopPayorList;
